import { Button, Flex, TextField } from "@radix-ui/themes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ResponsiveModal } from "./responsive-modal";

interface LinkInputModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (url: string) => void;
}

export function LinkInputModal({
  open,
  onOpenChange,
  onSubmit,
}: LinkInputModalProps) {
  const { t } = useTranslation();
  const [url, setUrl] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    // Basic URL validation
    if (!url || !url.trim()) {
      setError(t("general.files.url_empty"));
      return;
    }

    try {
      const parsedUrl = new URL(url);
      if (!parsedUrl.protocol.startsWith("http")) {
        setError(t("general.files.url_invalid"));
        return;
      }
      setError(null);
      onSubmit(url);
      onOpenChange(false);
      setUrl("");
    } catch (e) {
      setError(t("general.files.url_invalid"));
    }
  };

  const footer = (
    <Flex gap="3" justify="end">
      <Button variant="soft" color="gray" onClick={() => onOpenChange(false)}>
        {t("general.cancel")}
      </Button>
      <Button onClick={handleSubmit}>{t("general.confirm")}</Button>
    </Flex>
  );

  return (
    <ResponsiveModal
      isOpen={open}
      onClose={() => onOpenChange(false)}
      title={t("general.files.enter_url")}
      height="auto"
      maxHeight="90vh"
      footer={footer}
    >
      <div>
        <div className="mb-4">{t("general.files.url_description")}</div>

        <Flex direction="column" gap="3">
          <TextField.Root
            placeholder={t("components.link_input.placeholder")}
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          />
          {error && <div className="text-red-500 text-sm mt-1">{error}</div>}
        </Flex>
      </div>
    </ResponsiveModal>
  );
}
